import { Box, Button, Typography, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const SaveSessionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "0",
  width: "100%",
});

export const SaveSessionTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: 600,
  color: colors.text.primary,
  marginBottom: "8px",
  textAlign: "center",
});

export const SaveSessionSubtitle = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  color: colors.text.secondary,
  marginBottom: "32px",
  textAlign: "center",
  maxWidth: "500px",
});

export const InputLabel = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  color: colors.text.primary,
  marginBottom: "8px",
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "16px",
  marginTop: "8px",
  justifyContent: "center",
  width: "100%",
});

export const CancelButton = styled(Button)({
  minWidth: "120px",
  height: "48px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  color: colors.primary.main,
  border: `1px solid ${colors.primary.main}`,
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "rgba(58, 138, 185, 0.08)",
  },
});

export const SaveButton = styled(Button)({
  minWidth: "120px",
  height: "48px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: colors.amber.main,
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: colors.amber.dark,
  },
  "&:disabled": {
    backgroundColor: colors.border.light,
    color: colors.text.secondary,
  },
});

export const WarningTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  color: "#D32F2F",
  marginBottom: "8px",
  textAlign: "center",
});

export const WarningMessage = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  color: colors.text.secondary,
  textAlign: "center",
});
